export class IssueSelfHelpModel {
  id: string;
  type: string;
  issueId: string;
  isActive: boolean;
  elements: Array<any>;
  issueName?: string;
  elementType: string;
}
